<template>
    <layout-basic>
        <v-container>
            <section class="container-small banner-text">
                <v-row>
                    <v-col cols="12" md="12">
                        <div class="privay-content mb-50">

                            <p><span>IMPROVE's Terms and Conditions</span></p>

                            <p><i><span>Updated: March 2023</span></i></p>

                            <p><span>If you are using IMPROVE, then your company
                                    has given consent to these terms.</span></p>

                            <p><b><span>IMPROVE : End User licence agreement</span></b></p>

                            <p><span>This is your End User Licence Agreement for
                                    IMPROVE. Please read this carefully before using the IMPROVE service and you
                                    may want to retain a copy for your records. When you accept these terms, you
                                    confirm that you are duly authorised on behalf of the Client to place an order
                                    for IMPROVE subject to the terms and conditions set out below. You also warrant
                                    that the information submitted in signing up is correct and accurate to the
                                    best of your knowledge.</span></p>

                            <p><b><span>A: PROPERTY OF IMPROVE</span></b><span>&nbsp;FOLLOWING ACCEPTANCE OF THIS END USER
                                    LICENCE AGREEMENT YOU
                                    MAY ACCESS AND USE THE IMPROVE SOFTWARE THROUGH OUR SERVER. THE COPYRIGHT,
                                    DATABASE RIGHTS AND ANY OTHER INTELLECTUAL PROPERTY RIGHTS IN THE PROGRAMS AND
                                    DATA WHICH CONSTITUTE THIS SOFTWARE PRODUCT, ARE AND REMAIN THE PROPERTY OF IMPROVE
                                    PRODUCTIONS LTD (‘IMPROVE’, ‘WE’, ‘US’ AND ‘OUR’).</span></p>

                            <p><b><span>B: LICENCE ACCEPTANCE PROCEDURE</span></b><span>&nbsp;BY CLICKING ON THE ACCEPTANCE
                                    BUTTON DURING THE REGISTRATION
                                    PROCEDURE, YOU INDICATE ACCEPTANCE OF THIS END USER LICENCE AGREEMENT AND THE
                                    LIMITED WARRANTY AND LIMITATION OF LIABILITY SET OUT IN THIS END USER LICENCE
                                    AGREEMENT. SUCH ACCEPTANCE IS ON BEHALF OF ANY CORPORATE ENTITY WHICH EMPLOYS
                                    YOU OR WHICH YOU REPRESENT (‘CLIENT’). IN THIS END USER LICENCE AGREEMENT,
                                    ‘YOU’ INCLUDES BOTH THE READER AND ANY CLIENT. YOU SHOULD THEREFORE READ THIS
                                    END USER LICENCE AGREEMENT CAREFULLY BEFORE CLICKING ON THE ACCEPTANCE FIELD.
                                    IF YOU DO NOT AGREE TO THE TERMS OF THIS END USER LICENCE AGREEMENT, DO NOT USE
                                    THE WEBSITE OR THE SERVICE.</span></p>

                            <p><b><span>C: USER REJECTION</span></b><span>&nbsp;IMPROVE MAY IN OUR ABSOLUTE DISCRETION
                                    REJECT YOUR COMPANY
                                    FROM USING THE IMPROVE SERVICE WITHIN 21 DAYS OF SUBMISSION, IN WHICH CASE YOU
                                    WILL BE NOTIFIED OF SUCH REJECTION BY E-MAIL AND SHALL BE REFUNDED ANY
                                    SUBSCRIPTION FEES PAID TO IMPROVE.</span></p>

                            <p style='margin-left:.25in;text-indent:-.25in'><span>1.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><b><span>Definitions</span></b></p>

                            <p><span>The following terms as used in this
                                    Agreement have the following meanings:</span></p>

                            <p><b><span>“Agreement”</span></b><span>&nbsp;means
                                    this End User Licence Agreement which may be amended by IMPROVE from time to
                                    time in accordance with its terms;</span></p>

                            <p><b><span>&quot;Business Day&quot;</span></b><span> means a day other than a Saturday, Sunday
                                    or public holiday in
                                    England when banks in London are open for business;</span></p>

                            <p><b><span>&quot;Card Details&quot;</span></b><span> means valid credit or debit card details
                                    provided by the Client for
                                    payment of the Fees;</span></p>

                            <p><b><span>“IMPROVE”</span></b><span>&nbsp;means
                                    the Online Training platform managed by IMPROVE and provided through the
                                    Website and other properties;</span></p>

                            <p><b><span>“IMPROVE Technology”</span></b><span>&nbsp;means all the proprietary technology used
                                    in delivering the
                                    Service (including the software, hardware, products, processes, algorithms,
                                    user interfaces, know-how, techniques, designs and other tangible or intangible
                                    technical material or information) made available to the Client by IMPROVE in
                                    providing the Service;</span></p>

                            <p><b><span>“Client”, “you”, “yours”</span></b><span>&nbsp;means the corporate entity or
                                    organisation ordering the
                                    Service(s);</span></p>

                            <p><b><span>“Client Data”</span></b><span>&nbsp;means any data, information or material provided
                                    or submitted
                                    by or on behalf of the Client to IMPROVE and/or the Service or generated by the
                                    Service in the course of using the Service including but not limited to
                                    employee data held in the Service;</span></p>

                            <p><b><span>“Content”</span></b><span>&nbsp;means
                                    the documents, software, materials, products and services contained or made
                                    available to the Client in the course of using the Service;</span></p>

                            <p><b><span>&quot;Data Protection Legislation&quot; </span></b><span>means (i) unless and until
                                    the GDPR is no longer directly applicable
                                    in the UK, the General Data Protection Regulation ((EU) 2016/679) and any
                                    national implementing laws, regulations and secondary legislation, as amended
                                    or updated from time to time, in the UK and then (ii) any successor legislation
                                    to the GDPR or the Data Protection Act 1998.</span></p>

                            <p><b><span>“Defect”</span></b><span>&nbsp;means
                                    an error in the operation of the Service that causes the Service to fail to
                                    operate substantially as documented;</span></p>

                            <p><b><span>“Effective Date”</span></b><span>&nbsp;means the date upon which this Agreement is
                                    accepted by the
                                    Client;</span></p>

                            <p><b><span>“Intellectual Property Rights”</span></b><span>&nbsp;means unpatented inventions,
                                    patent applications, patents,
                                    design rights, copyrights (including rights in computer software), trade marks,
                                    service marks, trade names, domain name rights, database rights, design rights,
                                    mask work rights, know-how and other trade secret rights, and all other
                                    intellectual property rights, derivatives thereof, and forms of protection of a
                                    similar nature anywhere in the world;</span></p>

                            <p><b><span>“Law”</span></b><span>&nbsp;means
                                    any applicable law (statutory, common or otherwise), legislation (primary or
                                    secondary), statutory provision, statutory instrument, constitution, treaty,
                                    convention, ordinance, equitable principle, code, directive, edict, decree,
                                    rule, order, requirement, regulation, guidance, executive order, or other
                                    similar authority issued, enacted, adopted, promulgated, implemented, applied,
                                    or otherwise put into legal effect by or under the authority of any
                                    governmental entity in any relevant jurisdiction;</span></p>

                            <p><b><span>&quot;License Administrator(s)&quot; </span></b><span>means those Users who are
                                    authorised to administer the Client use of
                                    the Service;</span></p>

                            <p><b><span>&quot;License Term&quot; </span></b><span>means the period during which the Client
                                    is licensed to use the
                                    Service pursuant to this Agreement, being the Initial Term together with any
                                    Renewal Terms;</span></p>

                            <p><b><span>&quot;Initial Term&quot; </span></b><span>means the period of 36 months beginning
                                    on the date the Client first pays for the Service;</span></p>

                            <p><b><span>&quot;Renewal Term&quot; </span></b><span>means each further period of 36 months
                                    for which this Agreement renews under clause 2;</span></p>

                            <p><b><span>&quot;Trial Period&quot; </span></b><span>means the initial period of 14 days from
                                    the Effective Date;</span></p>

                            <p><b><span>&quot;Period&quot; </span></b><span>means each period of one year within the
                                    License Term. The first Period begins on the date on which the Client first
                                    pays for the Service and each later Period begins on the anniversary of that
                                    date. Such date shall be recorded in the administration pages of the
                                    Service.</span></p>

                            <p><b><span>&quot;Pricing Plan&quot; </span></b><span>means the schedule of fees and billing
                                    terms currently in force
                                    which can be viewed at:&nbsp;IMPROVE.online/pricing&nbsp;. IMPROVE may replace
                                    the Pricing Plan on 30 days prior written notice (including by email or though
                                    the Administration pages in the Service) and for the avoidance of doubt such
                                    new Pricing Plan may increase the Fees payable and/or introduce new Fees. A
                                    replacement Pricing Plan applies to Clients who first pay for the Service after
                                    it comes into force. It does not change the Fees payable by a Client for the
                                    remainder of that Client's Initial Term, which are fixed at the amounts in the
                                    Pricing Plan (or the Client's signed Master Service Agreement) in force when the
                                    Client first paid for the Service.</span></p>

                            <p><b><span>“Service(s)”</span></b><span>&nbsp;means
                                    the online Human Resource services developed, operated, and maintained by IMPROVE
                                    (and its licensors, where applicable), or ancillary online or offline products
                                    and services provided to the Client by IMPROVE, to which the Client is being
                                    granted access under this Agreement, including the IMPROVE Technology and the
                                    Content;</span></p>

                            <p><b><span>“User(s)”</span></b><span>&nbsp;means
                                    the Client’s employees, representatives, consultants, contractors or agents who
                                    are authorised to use the Service and have been supplied user identifications
                                    and passwords by the Client (or by IMPROVE at the Client's request); and</span></p>

                            <p><b><span>“Website”</span></b><span>&nbsp;means
                                    IMPROVE.online</span></p>

                            <p style='margin-left:.25in;text-indent:-.25in'><b><span>2.<span
                                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></b><b><span>Trial Period &amp; Duration</span></b></p>

                            <p><span>The Services will be provided free of
                                    charge for the Trial Period only. Thereafter the Client will:</span></p>

                            <p CxSpFirst style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>i.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>provide Card Details for payment of the Fees
                                    referred to, or</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>ii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>at IMPROVE’s sole discretion arrange for the
                                    payment of Fees by invoice or direct debit</span></p>

                            <p><span>failing which IMPROVE may immediately cease
                                    provision of the Services</span></p>

                            <p><span>Once the Client has paid for the Service, this Agreement
                                    continues for the Initial Term of 36 months and then renews automatically for
                                    successive Renewal Terms of 36 months each, unless either party gives the other
                                    at least 90 days’ written notice of non-renewal before the end of the Initial
                                    Term or the then-current Renewal Term. The Services shall be provided throughout
                                    the License Term for so long as the Fees are paid as set out below, unless and
                                    until this Agreement is terminated in accordance with these terms and
                                    conditions.</span></p>

                            <p style='margin-left:.25in;text-indent:-.25in'><b><span>3.<span
                                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></b><b><span>Privacy; Disclosure</span></b></p>

                            <p><span>IMPROVE's Privacy Policy in relation to the
                                    Client's use of the Service may be viewed at IMPROVE.online, and is
                                    incorporated into this Agreement by reference. IMPROVE reserves the right to
                                    modify its privacy policy in its reasonable discretion from time to time. With
                                    regard to any personal data input by or collected from the Client that may be
                                    stored or processed in the IMPROVE system, such data shall be stored and
                                    processed by IMPROVE in accordance with UK data protection legislation. Note
                                    that because the Service is a hosted, online application, IMPROVE occasionally
                                    may need to notify all Users of the Service of important announcements
                                    regarding the operation of the Service. The Client agrees that IMPROVE can
                                    disclose the fact that the Client is a user of the Service.</span></p>

                            <p><span>If you do not agree with IMPROVE's Privacy Policy
                                    then please do not use the Website or the Service.</span></p>

                            <p style='margin-left:.25in;text-indent:-.25in'><b><span>4.<span
                                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></b><b><span>Registration</span></b></p>

                            <p><span>Upon signing up for the Service and at
                                    subsequent times as requested by IMPROVE, You agree to provide to IMPROVE your
                                    true, accurate, current, and complete personal name and/or business name, admin
                                    name, billing address, the addresses where the Service will primarily be used,
                                    email address, contact phone number, credit/debit card information, and other
                                    data which may be necessary to administer your account (collectively, “<b>Registration
                                        Data</b>”). You represent and warrant that the information you provide is
                                    accurate, current, and complete, and agree to promptly update any of the
                                    information if it changes.</span></p>

                            <p><span>If you provide Registration Data that is,
                                    or that IMPROVE suspects to be, false, inaccurate, not current, incomplete,
                                    fraudulent, or otherwise unlawful, IMPROVE has the right, in its sole
                                    discretion, to suspend or terminate the Service and refuse any and all current
                                    or future use of the Service by you, your business(es), affiliates and all
                                    users of your account. At all times, you shall maintain and promptly update
                                    Registration Data.</span></p>

                            <p style='margin-left:.25in;text-indent:-.25in'><b><span>5.<span
                                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></b><b><span>Licence Grant and Restrictions</span></b></p>

                            <p><span>Subject to and conditional upon the
                                    Client's compliance with the terms of this Agreement, IMPROVE hereby grants to
                                    the Client a non-exclusive, limited, personal, revocable, non-transferable,
                                    right to use the Service, solely for the Client's own internal business
                                    purposes, subject to the terms and conditions of this Agreement.</span></p>

                            <p><span>All rights not expressly granted to the
                                    Client are reserved by IMPROVE and its licensors.</span></p>

                            <p><span>The Client may not access the Service if
                                    they are a direct competitor of IMPROVE or any of IMPROVE’s businesses or
                                    associated companies, except with IMPROVE’s prior written consent.</span></p>

                            <p><span>In addition, the Client may not access the
                                    Service for purposes of monitoring its availability, performance or
                                    functionality, or for any other benchmarking or competitive purposes. The
                                    Client shall not:</span></p>

                            <p CxSpFirst style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>i.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>license, sublicense, sell, resell, transfer,
                                    assign, rent, lease, export, import, act as an intermediary or provider,
                                    distribute or otherwise commercially exploit or make available to any third
                                    party the Service or the Content in any way;</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>ii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>modify or make derivative works based upon the
                                    Service or the Content;</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span>iii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>create Internet “links” to the Service or
                                    “frame” or “mirror” any Content on any other server or wireless or
                                    Internet-based device; or</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span>iv.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>reverse engineer or access the Service in order
                                    to (a) build a competitive product or service, (b) build a product using
                                    similar ideas, features, functions or graphics of the Service, or (c) copy any
                                    ideas, features, functions or graphics of the Service.</span></p>

                            <p><span>The Client may use the Service only for
                                    internal business purposes and shall not (not authorise any third party to):</span></p>

                            <p CxSpFirst style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>i.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>store infringing, obscene, threatening,
                                    libellous, or otherwise unlawful or tortious material, including material
                                    harmful to children or in violation of third party privacy rights;</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>ii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>store material containing software viruses, worms,
                                    Trojan horses or other harmful computer code, files, scripts, agents or
                                    programs;</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span>iii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>interfere with or disrupt the integrity or
                                    performance of the Service or the data contained therein; or</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span>iv.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>attempt to gain unauthorised access to the
                                    Service or its related systems or networks.</span></p>

                            <p><span>IMPROVE, in our sole discretion, reserves
                                    the right to add, remove, or modify features or functions, or to provide fixes,
                                    updates and upgrades, to IMPROVE and the Service. You acknowledge and agree
                                    that IMPROVE has no obligation to make available to You any subsequent versions
                                    of IMPROVE or the Service. In addition, you and IMPROVE acknowledge that no
                                    third-party has any obligation whatsoever to furnish maintenance or support
                                    services with respect to IMPROVE or the Service and that IMPROVE is solely
                                    responsible for the provision of maintenance and support as provided in this
                                    Agreement and to the extent such maintenance and support is required under
                                    applicable Law.</span></p>

                            <p><span>IMPROVE and the Service may be integrated
                                    with third party applications, websites, and services (“<b>Third Party Services</b>”)
                                    to make available content, products, and/or services to you. These Third Party
                                    Services may have their own terms and conditions of use and privacy policies
                                    and your use of these Third Party Services will be governed by and subject to
                                    such terms and conditions and privacy policies. You understand and agree that IMPROVE
                                    does not endorse and is not responsible or liable for the behaviour, features,
                                    or content of any Third Party Services or for any transaction you may enter
                                    into with the provider of any such Third Party Services.</span></p>

                            <p style='margin-left:.25in;text-indent:-.25in'><b><span>6.<span
                                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></b><b><span>The Client's Responsibilities</span></b></p>

                            <p><span>The Client is solely responsible for all
                                    activity occurring under their User accounts and shall abide by all applicable
                                    Law in connection with their and their Users’ use of the Service, including
                                    those related to data privacy, international communications and the
                                    transmission of technical or personal data. The Client shall:</span></p>

                            <p CxSpFirst style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>i.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>notify IMPROVE immediately of any unauthorised
                                    use of any password or account or any other known or suspected breach of
                                    security;</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>ii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>report to IMPROVE immediately and use reasonable
                                    efforts to stop immediately any copying or distribution of Content that is
                                    known or suspected by the Client or their Users; and</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span>iii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>not impersonate another IMPROVE User or provide
                                    false identity information to gain access to or use the Service.</span></p>

                            <p><span>You shall not use IMPROVE or the Service
                                    for any illegal, fraudulent, improper, or abusive purpose or in any way that
                                    interferes with IMPROVE’s ability to provide a high quality Service to other
                                    clients, prevents or restricts other clients from using the Service, or damages
                                    any of IMPROVE's or other clients’ property. If IMPROVE finds that you are
                                    using the Service for anything other than as permitted by this Agreement or for
                                    any of the prohibited uses in this Agreement, IMPROVE may at our sole
                                    discretion terminate your Service with immediate effect. Prohibited uses
                                    include, but are not limited to:</span></p>

                            <ul style='margin-top:0in' type=disc>
                                <li><span>Behaviour that is illegal, obscene,
                                        threatening, harassing, defamatory, libellous, deceptive, fraudulent,
                                        malicious, infringing, tortious, or invasive of another’s privacy.</span></li>
                                <li><span>Harvesting or otherwise collecting
                                        information about others, including email addresses, without their consent
                                        or in breach of applicable data protection or privacy laws.</span></li>
                                <li><span>Negligently, recklessly, knowingly, or
                                        intentionally transmitting any material that contains viruses, time bombs,
                                        Trojan horses, worms, malware, spyware, or any other programs that may be
                                        harmful or dangerous.</span></li>
                                <li><span>Transmitting any material that may infringe,
                                        misappropriate, or otherwise violate any third party's Intellectual
                                        Property Rights.</span></li>
                                <li><span>Using the Service in any way that
                                        interferes with other clients’ and third parties’ use and enjoyment of the
                                        Service or use the Service in any manner which disrupts, prevents or
                                        restricts any other client from using the Service.</span></li>
                                <li><span>Using or employing methods and/or devices
                                        that are designed or likely to take advantage of, bypass, exploit, or
                                        otherwise avoid the restrictions and limitations contained in this
                                        Agreement.</span></li>
                            </ul>

                            <p><span>You further understand and agree that:</span></p>

                            <ul style='margin-top:0in' type=disc>
                                <li><span>You shall be solely liable for any
                                        transmissions sent through IMPROVE and the Service under your account,
                                        including the content of any transmission sent through the Service under
                                        your account.</span></li>
                                <li><span>You will abide by all applicable IMPROVE
                                        policies, procedures, and agreements related to IMPROVE and the Service.</span></li>
                            </ul>

                            <p><span>If we, in our sole discretion, consider you
                                    to be in breach of this Agreement, or likely to be in breach of this Agreement,
                                    we may take any action we think is necessary to protect IMPROVE, the Service
                                    and its users. We may:</span></p>

                            <p CxSpFirst style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>i.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>withdraw your right to use IMPROVE and the
                                    Service;</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>ii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>remove Client Data from IMPROVE;</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span>iii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>take legal proceedings against you;</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span>iv.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>disclose any information to law enforcement
                                    authorities we think is necessary or as required by Law.</span></p>

                            <p><span>These actions are not limited and we may
                                    take any other action we reasonably deem appropriate.</span></p>

                            <p><span>As you will be submitting and providing
                                    Client Data which may contain the personal data (and potentially sensitive
                                    personal data (as such terms are defined under the Act)) of Users and third
                                    parties, you acknowledge and accept that you are solely responsible for
                                    obtaining all required consents, authorisations and permissions from such Users
                                    and third parties to enable you to provide such information to us and to grant
                                    to us the rights set forth in this EULA and the Privacy Policy. It is your
                                    responsibility to ensure that all such Users and third parties are aware of and
                                    accept the terms of this EULA and the privacy policy and that you have obtained
                                    explicit consent of Users to our processing any of their sensitive personal
                                    data in accordance with this EULA and the privacy policy. You may not provide
                                    us with any Client Data or other information containing personal data of Users
                                    or third parties unless and until you have obtained all necessary consents,
                                    authorisations and permissions to do so.</span></p>

                            <p style='margin-left:.25in;text-indent:-.25in'><b><span>7.<span
                                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></b><b><span>Account Information and Data</span></b></p>

                            <p><span>IMPROVE does not own any of the Client
                                    Data. The Client, not IMPROVE, shall have sole responsibility for the accuracy,
                                    quality, integrity, legality, reliability, appropriateness, and intellectual
                                    property ownership or right to use of all Client Data, and IMPROVE shall not be
                                    responsible or liable for the deletion, correction, destruction, damage, loss
                                    or failure to store any Client Data.</span></p>

                            <p><span>In the event this Agreement is terminated
                                    (other than by reason of the Client's breach), IMPROVE shall advise the Client
                                    how it may retrieve the Client Data but it will be the sole responsibility of
                                    the Client to retrieve a copy of their Client Data within 30 days of
                                    termination after which time, to the extent permitted by applicable Law, IMPROVE
                                    may delete all such data.</span></p>

                            <p><span>IMPROVE reserves the right to withhold,
                                    remove and/or discard Client Data without notice for any breach by the Client
                                    without limitation. Upon termination by IMPROVE for any breach, the Client’s
                                    right to access or use Client Data immediately ceases, and IMPROVE shall have
                                    no obligation to maintain or store or forward any Client Data.</span></p>

                            <p style='margin-left:.25in;text-indent:-.25in'><b><span>8.<span
                                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span></span></b><b><span>Intellectual Property Ownership</span></b></p>

                            <p><span>You hereby grant to IMPROVE a perpetual,
                                    worldwide, royalty-free, fully paid-up, non-exclusive, non-transferable (except
                                    in connection with an assignment of this Agreement) licence to copy, store,
                                    share, record, transmit, display, view, print, and use Client Data to the
                                    extent required to provide or IMPROVE IMPROVE and the Service and in accordance
                                    with our privacy policy.</span></p>

                            <p><span>IMPROVE alone (and its licensors, where
                                    applicable) shall own all right, title and interest, including all related
                                    Intellectual Property Rights, in and to the IMPROVE Technology, the Content,
                                    and the Service and any suggestions, ideas, enhancement requests, feedback,
                                    recommendations or other information provided by the Client or any other party
                                    relating to the Service. This Agreement is not a sale and does not convey to
                                    the Client any rights of ownership in or related to the Service, the IMPROVE
                                    Technology or the Intellectual Property Rights owned by IMPROVE. The IMPROVE
                                    name, the IMPROVE logo, and the product names associated with the Service are
                                    trade marks of IMPROVE or third parties, and no right or licence is granted to
                                    use them.</span></p>

                            <p><span>You are only entitled to the limited use of
                                    the rights expressly granted to you in this Agreement. You will not take any
                                    action to jeopardise, limit, restrict or interfere with IMPROVE’s Intellectual
                                    Property Rights or do any other action or thing which otherwise has the effect
                                    of jeopardising, limiting, restricting or interfering with IMPROVE’s ownership
                                    or use of such Intellectual Property Rights. You acknowledge and agree that any
                                    unauthorised use of the IMPROVE Technology and the Content is a breach of this
                                    Agreement, as well as a breach of applicable intellectual property laws. You
                                    acknowledge and understand that all title and rights in and to any third party
                                    content that may be accessed through IMPROVE or the Service is the property of
                                    the respective content owners and may be protected by applicable copyright or
                                    other intellectual property laws and treaties.</span></p>

                            <p style='margin-left:.25in;text-indent:-.25in'><span>9.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><b><span>Fees and Renewal</span></b></p>

                            <p><span>If the Client wishes to continue with the
                                    Service after the Trial Period the Client must provide Card Details, or obtain
                                    the permission of IMPROVE to pay by invoice or direct debit. The provision of any
                                    such Card Details, either upon the Effective Date or subsequently, shall be the
                                    Client's authorisation to charge all Fees to those Card Details.</span></p>

                            <p><span>Fees are payable annually in advance. The Fees for
                                    the first year of the Initial Term, together with any one-off IMPROVE Launch
                                    Programme fee, are payable when the Client first pays for the Service, and the
                                    Fees for each later year are payable on or before the anniversary of that date.
                                    The Fees for each year of the Initial Term are the amounts stated in the Pricing
                                    Plan (or the Client's signed Master Service Agreement) in force when the Client
                                    first paid for the Service. IMPROVE collects the Fees:</span></p>

                            <p CxSpFirst style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>i.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>by charging the Client’s card using the Card
                                    Details, or if agreed</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>ii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>by invoice, payable within 30 days, or by direct debit from
                                    the Client’s bank account.</span></p>

                            <p><span>All payment obligations are non-cancellable
                                    and all amounts paid are non-refundable. The Client is responsible for paying
                                    for all Services ordered for the entire License Term. If the Client wishes to
                                    amend the number of employees with access to the Service the Client must make
                                    any such amendment through the Administration pages in the Service or by
                                    contacting IMPROVE, and a pro-rata payment for the remainder of the current
                                    Period will be due immediately.</span>
                            </p>

                            <p><span>Fees for other services will be charged on
                                    an as-quoted basis.</span></p>

                            <p><span>IMPROVE’s fees are exclusive of all taxes,
                                    levies, or duties imposed by taxing authorities, and the Client shall be
                                    responsible for payment of all such taxes, levies, or duties.</span></p>

                            <p><span>All pricing terms are confidential, and the
                                    Client agrees not to disclose them to any third party.</span></p>

                            <p><span>The Client warrants that it has provided IMPROVE
                                    with complete and accurate billing and contact information. The Client agrees
                                    to provide IMPROVE with updated information within 30 days of any change to it
                                    through the Client's Administration Page in the Service. If the contact
                                    information the Client has provided is false or fraudulent, IMPROVE reserves
                                    the right to terminate access to the Service in addition to any other legal
                                    remedies.</span></p>

                            <p><span>IMPROVE is only available to corporate
                                    entities or organisations and all billing will be in £ sterling.</span></p>

                            <p><span>If the Client believes their bill is
                                    incorrect they must notify IMPROVE in writing within 30 days of the date of the
                                    disputed invoice, following which IMPROVE shall assess whether any adjustment
                                    or credit is due.</span></p>

                            <p><b><span>Non-Payment and Suspension</span></b></p>

                            <p><span>In addition to any other rights granted to IMPROVE
                                    herein, IMPROVE reserves the right to suspend or terminate this Agreement and
                                    the Client's access to the Service if their account falls into arrears. If any
                                    sum payable under this Agreement is not paid within 7 days after the due date
                                    or any payment is rejected revoked or refused then (without prejudice to the
                                    Company's other rights and remedies) IMPROVE reserves the right to suspend the
                                    provision of any Services being rendered and to delete all Client preferences
                                    and settings in relation to the IMPROVE system as set up for the Client and/or
                                    to charge interest which shall accrue on a daily basis on such due amounts at
                                    an annual rate equal to 3% over LIBOR from time to time, commencing on the due
                                    date and continuing until fully paid, whether before or after judgment.</span></p>

                            <p><span>Such interest shall be paid on demand by
                                    the Client.</span></p>

                            <p><span>IMPROVE reserves the right to impose a
                                    reconnection fee in the event the Client is suspended and thereafter requests
                                    access to the Service.</span></p>

                            <p><b><span>Termination Upon Expiration</span></b></p>

                            <p><span>This Agreement will automatically expire at
                                    the end of the Trial Period unless the Client has paid for the Service,
                                    provided Card Details or obtained IMPROVE’s permission to pay by invoice or
                                    direct debit.</span></p>

                            <p><b><span>Termination By Notice</span></b></p>

                            <p><span>This Agreement continues for the Initial Term and
                                    renews automatically for successive Renewal Terms of 36 months. Either party may
                                    prevent it renewing by giving the other at least 90 days’ written notice before
                                    the end of the Initial Term or the then-current Renewal Term, in which case this
                                    Agreement terminates at the end of that term. The Client may give notice by
                                    email to info@improve.online. Notice given later than 90 days before the end of
                                    a term takes effect at the end of the following term.</span></p>

                            <p><span>IMPROVE may terminate this Agreement if IMPROVE
                                    decides to withdraw the Service (whether on a temporary or permanent basis) or
                                    decides to no longer permit access to the Service by the Client (by use of
                                    passwords or changes of passwords or by any other means). No refunds shall be
                                    due in cases in which Clients have paid for but not received Services.</span></p>

                            <p><b><span>Termination for Cause</span></b></p>

                            <p><span>IMPROVE may terminate this Agreement if the
                                    Client commits any material, or persistent, breach of any of the terms of this
                                    Agreement and (if such a breach is remediable) fails to remedy that breach
                                    within 30 days of being notified of the breach. Without limit to the generality
                                    of the foregoing any breach of the Client's payment obligations or unauthorised
                                    use of the IMPROVE Technology or Service will be deemed a material and
                                    irremediable breach of this Agreement.</span></p>

                            <p><b><span>Termination Consequences</span></b></p>

                            <p><span>Upon any termination or suspension of your
                                    account, IMPROVE may immediately deactivate or delete your account and all
                                    related information and files in your account and/or restrict any further
                                    access to such files, information, or Service.</span></p>

                            <p><span>IMPROVE shall not be liable to you or any
                                    third party for any reason for terminating or suspending your use or access to IMPROVE
                                    or the Service.</span></p>

                            <p><span>The provisions of this Agreement relating
                                    to intellectual property ownership, Client representations and warranties,
                                    confidentiality, use policies and restrictions, storage of user information,
                                    publicity rights, payment terms, indemnification, force majeure, warranty
                                    disclaimers, limitations of liability, notices, assignment, modifications,
                                    interpretation, dispute resolution and choice of law shall survive termination
                                    or expiration of this Agreement for the maximum term allowable by Law.</span></p>

                            <p><span>Within 14 days of the termination of the
                                    contract the Client must pay to IMPROVE in full and without set off:</span></p>

                            <p CxSpFirst style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>i.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>the Fees due up until the date of such
                                    termination, and</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>ii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>any other sums due under this Agreement.</span></p>

                            <p><span>Any rights, remedies, obligations or liabilities
                                    of the parties that have accrued up to the date of termination, including the
                                    right to claim damages in respect of any breach of the Agreement which existed
                                    at or before the date of termination shall not be affected or prejudiced</span></p>

                            <p><b><span>Excess Data Storage Fees</span></b></p>

                            <p><span>Disk maximum storage space allowance
                                    provided to the Client is at the sole discretion of IMPROVE and IMPROVE
                                    reserves the exclusive right to amend this at any time without notice.</span></p>

                            <p style='margin-left:.25in;text-indent:-.25in'><b><span>10.<span
                                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                                        </span></span></b><b><span>Representations and Warranties</span></b></p>

                            <p><span>Each party represents and warrants that it
                                    has the legal power and authority to enter into this Agreement.</span></p>

                            <p><span>IMPROVE represents and warrants that it
                                    will provide the Service in a manner consistent with general industry standards
                                    reasonably applicable to the provision thereof and that the Service will
                                    perform substantially as documented under normal use and circumstances. The
                                    sole remedy for breach of this warranty shall be correction of any Defects by IMPROVE
                                    within a reasonable time from notification by the Client of the Defect that
                                    constitutes such a breach, providing that such remedial work is commercially
                                    practicable, and the Client provides all the information that may be necessary
                                    to assist IMPROVE in resolving the Defect, including sufficient information to
                                    enable IMPROVE to recreate the Defect.</span></p>

                            <p><span>You represent, warrant and undertake to IMPROVE
                                    that:</span></p>

                            <p CxSpFirst style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>i.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>the Client Data you provide or make available is
                                    accurate, current, and complete, and agree to promptly update any of the
                                    information if it changes;</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>ii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>you have obtained all rights, licences and consents
                                    necessary to grant the licences to IMPROVE pursuant to this Agreement;</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span>iii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>the Client Data will not infringe the rights of
                                    any third party, including any Intellectual Property Rights, rights in
                                    confidential information or rights in privacy;</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span>iv.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>you have obtained all necessary permissions and
                                    consents from any persons associated with or identifiable from the Client Data
                                    (including the Users);</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>v.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>your provision of the Client Data is made in
                                    compliance with all applicable Law and the processing and use of such Client
                                    Data by or on behalf of IMPROVE shall not cause IMPROVE to breach any
                                    applicable Law or infringe the rights of any third party.</span></p>

                            <p><span>&nbsp;</span></p>

                            <p style='margin-left:.25in;text-indent:-.25in'><span>11.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                                    </span></span><b><span>Confidential Information</span></b></p>

                            <p><span>IMPROVE will use its reasonable commercial
                                    endeavours to keep all Client Data confidential, providing that Client Data may
                                    be disclosed to IMPROVE’s employees, representatives, consultants, contractors
                                    or agents (who in turn will be legally bound to keep the Client Data
                                    confidential). The obligation to keep the Client Data confidential will not
                                    apply to any information that:</span></p>

                            <p CxSpFirst style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>i.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>is already known to the public; or</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>ii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>is required to be disclosed by Law, by any
                                    governmental or other regulatory authority, or by a court or other authority of
                                    competent jurisdiction, providing that IMPROVE will give the Client notice of
                                    the requirement to disclose of that disclosure as soon as practicable.</span></p>

                            <p><span>&nbsp;</span></p>

                            <p style='margin-left:.25in;text-indent:-.25in'><span>12.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                                    </span></span><b><span>Indemnification</span></b></p>

                            <p><span>The Client shall indemnify and hold IMPROVE,
                                    its licensors and each such party’s parent organisations, subsidiaries,
                                    affiliates, officers, directors, employees, attorneys and agents harmless from
                                    and against any and all claims, costs, damages, losses, liabilities and
                                    expenses (including legal fees and costs) arising out of or in connection with:</span>
                            </p>

                            <p CxSpFirst style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>i.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>a claim alleging that use or disclosure of the
                                    Client Data infringes the rights of, or has caused harm to, a third party
                                    (including the Users);</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>ii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>a claim, which if true, would constitute a
                                    violation by the Client of their representations and warranties under this
                                    Agreement; or</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span>iii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>a claim arising from the breach by the Client or
                                    their Users of this Agreement.</span></p>

                            <p><span>In connection with a claim for
                                    indemnification pursuant to this Clause 12, IMPROVE shall:</span></p>

                            <p CxSpFirst style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>i.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>give written notice of the claim promptly to the
                                    Client;</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>ii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>give the Client sole control of the defence and
                                    settlement of the claim (provided that the Client may not settle or defend any
                                    claim unless they unconditionally release IMPROVE of all liability and such
                                    settlement does not affect IMPROVE’s business or Service);</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span>iii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>provide to the Client all reasonably relevant
                                    and available information and assistance; and</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span>iv.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>not compromise or settle such claim, without
                                    your consent.</span></p>

                            <p><span>&nbsp;</span></p>

                            <p style='margin-left:.25in;text-indent:-.25in'><span>13.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span>Disclaimer
                                        of Warranties</span></b></p>

                            <p><span>IMPROVE and its licensors do not guarantee
                                    that:</span></p>

                            <p CxSpFirst style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>i.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>IMPROVE or the Service will operate error free
                                    or without interruption;</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>ii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>all program defects in relation to the Services
                                    will be corrected; or</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span>iii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>IMPROVE or the Service will operate with any
                                    hardware, software, system or data not identified in the ordering process.</span></p>

                            <p><span>All conditions, representations and
                                    warranties, whether express, implied, statutory or otherwise, including,
                                    without limitation, any implied warranty of satisfactory quality, fitness for a
                                    particular purpose, or non-infringement of third party rights, are hereby
                                    disclaimed to the maximum extent permitted by applicable Law by IMPROVE and its
                                    licensors. IMPROVE makes no representations or warranties that the Service is
                                    free of rightful claims of any third party for infringement or misappropriation
                                    of intellectual property or other proprietary rights.</span></p>

                            <p><span>In addition, IMPROVE makes no
                                    representation nor does it warrant, endorse, guarantee, or assume responsibility
                                    for any Third Party Services (or the content thereof).</span></p>

                            <p><span>Although every effort is made to ensure
                                    that data transmissions of Client Data are secure, IMPROVE makes no guarantees
                                    of security.</span></p>

                            <p style='margin-left:.25in;text-indent:-.25in'><b><span>14.<span
                                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                                        </span></span></b><b><span>Internet Delays</span></b></p>

                            <p><span>IMPROVE’s Service may be subject to limitations,
                                    delays, and other problems inherent in the use of the Internet and electronic
                                    communications. IMPROVE is not responsible for any delays, delivery failures,
                                    or other damage resulting from such problems.</span></p>

                            <p style='margin-left:.25in;text-indent:-.25in'><b><span>15.<span
                                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                                        </span></span></b><b><span>Force Majeure</span></b></p>

                            <p><span>In this Agreement, “force majeure” shall
                                    mean any cause preventing IMPROVE from performing any or all of IMPROVE’s
                                    obligations which arise from or are attributable to acts, events, omissions or
                                    accidents beyond IMPROVE’s reasonable control including without limitation
                                    strikes, lock-outs or other industrial disputes, acts of God, war, riot, civil
                                    commotion, malicious damage, compliance with any law or governmental order,
                                    rule, regulation or direction, accident, breakdown of plant or machinery, fire,
                                    flood, interruption or failure of utility service, including but not limited to
                                    electric power, gas or water or default of suppliers or sub-contractors. IMPROVE
                                    shall not be in breach of this Agreement if it is subject to a force majeure
                                    event, provided that it uses reasonable endeavours to notify you in writing of
                                    the nature and extent of the force majeure event causing IMPROVE’s failure or
                                    delay in performance. If the force majeure event prevails for a continuous
                                    period of more than 2 months, the Client may terminate this Agreement by giving
                                    14 days’ written notice to IMPROVE. On the expiry of this notice period, this
                                    Agreement will terminate. Such termination shall be without prejudice to IMPROVE’s
                                    rights in respect of any breach of this agreement occurring prior to such
                                    termination.</span></p>

                            <p style='margin-left:.25in;text-indent:-.25in'><b><span>16.<span
                                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                                        </span></span></b><b><span>Limitation of Liability</span></b></p>

                            <p><span>Nothing in this Agreement will exclude or
                                    limit IMPROVE’s liability for:</span></p>

                            <p CxSpFirst style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>i.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>death or personal injury caused by IMPROVE's
                                    negligence;</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>ii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>fraud or fraudulent misrepresentation; or</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span>iii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>any other liability which may not be excluded or
                                    limited under Applicable Law.</span></p>

                            <p><span>IMPROVE shall not be liable for any damages
                                    or losses as a result of a force majeure event, or from your or your Users’ use
                                    of a Third Party Service.</span></p>

                            <p><span>To the fullest extent permitted by Law, in
                                    no event shall IMPROVE or its affiliates be liable to you or any third party
                                    for indirect, incidental, consequential, or punitive damages of any kind
                                    whether arising under contract, warranty, tort (including negligence or strict
                                    liability), or any other theory of liability, even if IMPROVE has been informed
                                    in advance of such damages or such damages could have been reasonably foreseen
                                    by IMPROVE.</span></p>

                            <p><span>Without limiting the foregoing, IMPROVE
                                    shall not be liable for any of the following losses (whether direct, indirect,
                                    incidental or consequential):</span></p>

                            <p CxSpFirst style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>i.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>any loss of profits or other economic advantage;</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>ii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>any loss of data;</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span>iii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>any loss of goodwill; and/or</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span>iv.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>any loss of anticipated savings, arising in
                                    respect of any representation, statement, act or omission in connection with
                                    this Agreement, whether the claim arises under contract, tort,
                                    misrepresentation or breach of statutory duty.</span></p>

                            <p><span>The limitation of liability reflects the
                                    allocation of risk between the parties. The limitations specified in this
                                    section will survive and apply in any and all circumstances.</span></p>

                            <p style='margin-left:.25in;text-indent:-.25in'><b><span>17.<span
                                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                                        </span></span></b><b><span>Notice</span></b></p>

                            <p><span>IMPROVE may give notice by means of
                                    electronic mail to the Client's e-mail address on record in IMPROVE 's account
                                    information. Such notice shall be deemed to have been given upon the expiration
                                    12 hours after sending the email.</span></p>

                            <p style='margin-left:.25in;text-indent:-.25in'><span>18.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                                    </span></span><b><span>Modification to Terms</span></b></p>

                            <p><span>IMPROVE reserves the right to modify the
                                    terms and conditions of this Agreement or its policies relating to the Service
                                    at any time. Such modified terms and conditions will be issued or made
                                    available to the Client electronically via email or the Website and shall be
                                    deemed effective 12 hours after electronic delivery or notification. Continued
                                    use of the Service after any such changes shall constitute the Client’s consent
                                    to such changes.</span></p>

                            <p style='margin-left:.25in;text-indent:-.25in'><b><span>19.<span
                                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                                        </span></span></b><b><span>Assignment; Change in Control</span></b></p>

                            <p><span>This Agreement may not be assigned by the
                                    Client without the prior written approval of IMPROVE but may be assigned
                                    without the Client's consent by IMPROVE to:</span></p>

                            <p CxSpFirst style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>i.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>a parent or subsidiary;</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>ii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>an acquirer of assets; or</span></p>

                            <p style='text-indent:-.5in'><span><span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span>iii.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>a successor by merger.</span></p>

                            <p><span>Any purported assignment in violation of
                                    this section shall be void.</span></p>

                            <p><span>Any actual or proposed change in control of
                                    the Client that results or would result in a direct competitor of IMPROVE directly
                                    or indirectly owning or controlling 50% or more of the Client shall entitle IMPROVE
                                    to terminate this Agreement for cause immediately upon written notice.</span></p>

                            <p style='margin-left:.25in;text-indent:-.25in'><b><span>20.<span
                                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                                        </span></span></b><b><span>General</span></b></p>

                            <p><span>This Agreement shall be governed by and
                                    construed in accordance with the laws of England and Wales and the parties
                                    agree that any dispute relating to its terms or subject matter shall be subject
                                    to the exclusive jurisdiction of the English courts.</span></p>

                            <p><span>If any provision of this Agreement is held
                                    by a court of competent jurisdiction to be invalid or unenforceable, then such
                                    provision(s) shall be construed, as nearly as possible, to reflect the
                                    intentions of the invalid or unenforceable provision(s), with all other
                                    provisions remaining in full force and effect.</span></p>

                            <p><span>No joint venture, partnership, employment,
                                    or agency relationship exists between the Client and IMPROVE as a result of
                                    this Agreement or use of the Service.</span></p>

                            <p><span>The failure of IMPROVE to enforce any right
                                    or provision in this Agreement shall not constitute a waiver of such right or
                                    provision unless acknowledged and agreed to by IMPROVE in signed writing
                                    authorised by a director of IMPROVE.</span></p>

                            <p><span>This Agreement together with IMPROVE privacy
                                    policy and any copyright notices on the Website comprises the entire agreement
                                    between the Client and IMPROVE in relation to the Service and supersedes all
                                    prior or contemporaneous negotiations, discussions or agreements, whether written
                                    or oral, between the parties regarding the subject matter contained herein.</span></p>

                            <p><span>Where the Client has entered into a signed Master
                                    Service Agreement with IMPROVE, that agreement governs the licence term,
                                    renewal, notice periods and Fees. Where there is any conflict between these
                                    terms and conditions and the signed Master Service Agreement, the Master
                                    Service Agreement prevails. These terms and conditions continue to apply to
                                    free trial accounts and to anything the signed Master Service Agreement does
                                    not cover.</span></p>

                            <p style='margin-left:.25in;text-indent:-.25in'><b><span>21.<span
                                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                                        </span></span></b><b><span>Third parties</span></b></p>

                            <p><span>For the purposes of the Contracts (Rights
                                    of Third Parties) Act 1999 this Agreement is not intended to, and does not,
                                    give any person who is not a party to it any right to enforce any of its
                                    provisions.</span></p>

                            <p style='margin-left:.25in;text-indent:-.25in'><b><span>22.<span
                                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                                        </span></span></b><b><span>Acceptance of Agreement</span></b></p>

                            <p><span>By ticking the acceptance field during the
                                    registration process, you confirm acceptance of this End User Licence
                                    Agreement, which shall constitute a binding contract between IMPROVE and the
                                    Client, subject to the ability of IMPROVE within 21 days to reject the Client.</span>
                            </p>

                            <p style='margin-left:.25in;text-indent:-.25in'><span>23.<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span>Company
                                        information</span></b></p>

                            <p><span>Improve Production Ltd is incorporated
                                    under the laws of England, with company number 11320233. </span></p>

                            <p><span>IMPROVE’s registered address is:</span></p>

                            <p style='margin-bottom:0in'><span>Improve
                                    Productions Ltd</span></p>

                            <p style='margin-bottom:0in'><span>Space City, Dock</span></p>

                            <p style='margin-bottom:0in'><span>75 Exploration Drive</span></p>

                            <p style='margin-bottom:0in'><span>Leicester</span></p>

                            <p style='margin-bottom:0in'><span>LE4 5NU</span></p>

                            <p style='margin-bottom:0in'><span>&nbsp;</span></p>

                            <p><b><span>Schedule One – Which browsers are
                                        supported by IMPROVE?</span></b></p>

                            <p CxSpFirst><span>Supported Desktop Browsers </span></p>

                            <p style='margin-left:1.0in;text-indent:-.25in'><span style='font-family:Symbol'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>Internet Explorer (IE11)^</span></p>

                            <p style='margin-left:1.0in;text-indent:-.25in'><span style='font-family:Symbol'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>Microsoft Edge*</span></p>

                            <p style='margin-left:1.0in;text-indent:-.25in'><span style='font-family:Symbol'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>Mozilla Firefox*</span></p>

                            <p style='margin-left:1.0in;text-indent:-.25in'><span style='font-family:Symbol'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>Google Chrome*</span></p>

                            <p style='margin-left:1.0in;text-indent:-.25in'><span style='font-family:Symbol'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>Safari*</span></p>

                            <p><span>&nbsp;</span></p>

                            <p><span>Supported Operating
                                    Systems</span></p>

                            <p style='margin-left:1.0in;text-indent:-.25in'><span style='font-family:Symbol'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>Microsoft Windows 8 and or higher**</span></p>

                            <p style='margin-left:1.0in;text-indent:-.25in'><span style='font-family:Symbol'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>OSX (Last two major releases)</span></p>

                            <p style='margin-left:1.0in;text-indent:-.25in'><span style='font-family:Symbol'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>Most Linux distributions</span></p>

                            <p><span>&nbsp;</span></p>

                            <p><span>Supported Mobile Operating
                                    Systems</span></p>

                            <p style='margin-left:1.0in;text-indent:-.25in'><span style='font-family:Symbol'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>IOS 9</span></p>

                            <p style='margin-left:1.0in;text-indent:-.25in'><span style='font-family:Symbol'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>Android 6.0</span></p>

                            <p><span>Such browsers are
                                    supported on the following mobile operating systems:</span></p>

                            <p style='margin-left:1.0in;text-indent:-.25in'><span style='font-family:Symbol'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>IOS: Default browsers in version 9 and above</span></p>

                            <p style='margin-left:1.0in;text-indent:-.25in'><span style='font-family:Symbol'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>Android: Default browser in version 6.0 and above</span></p>

                            <p><span>&nbsp;</span></p>

                            <p><span>Browser Settings</span></p>

                            <p style='margin-left:1.0in;text-indent:-.25in'><span style='font-family:Symbol'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>JavaScript must be enabled</span></p>

                            <p style='margin-left:1.0in;text-indent:-.25in'><span style='font-family:Symbol'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>Cookies must be enabled</span></p>

                            <p style='margin-left:1.0in;text-indent:-.25in'><span style='font-family:Symbol'>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span><span>Local Storage must be enabled</span></p>

                            <p><span>&nbsp;</span></p>

                            <p><b><span>Browser Notes</span></b></p>

                            <p><span>*Microsoft Edge, Firefox,
                                    Chrome and Safari follow a continuous release policy that makes difficult to
                                    fix a minimum version. For this reason, following the market recommendation we
                                    will support the last 2 major version of each of these browsers.</span></p>

                            <p><span>&nbsp;</span></p>

                            <p><span>**Note for Windows XP
                                    Users</span></p>

                            <p><span>Windows XP is no longer
                                    supported by its original vendor, Microsoft, but if your organisation has
                                    internal policies that have extended the use of Windows XP, IMPROVE recommends
                                    that your PCs be migrated to MS Windows 8 or above at your earliest
                                    convenience. If you are unable to upgrade your PCs at this time, we recommend
                                    installing the latest version of Google Chrome, as a temporary solution.<br>
                                    <br>
                                </span></p>

                            <p><span>^Note for Internet Explorer
                                    11</span></p>

                            <p><span>We will no longer support Microsoft
                                    Internet Explorer 11 in January 2020. As part of this process, IMPROVE will no
                                    longer offer maintenance and support related to issues with your platform that
                                    occur only on Internet Explorer 11 starting on July 31, 2019. Only critical
                                    issues related to your platform will be supported fixed by IMPROVE’s
                                    development teams, if necessary. In the meantime, we strongly encourage you to
                                    start moving you and your learners to one of our other supported browsers.</span></p>

                        <p><span>IMPROVE strongly recommends that clients
                                maintain updated operating systems (both desktop and mobile) aligned to the
                                latest release made available by the respective vendor.</span></p>

                        <p><span>Note about Flash Content </span></p>

                        <p><span>Please keep in mind that Flash content is
                                not playable on iOS devices. Flash was deprecated on Android devices in 2012,
                                and desktop browsers are going to deprecate it by 2020. When adding learning
                                content to your courses, be sure to avoid adding Flash-based content (in SCORM
                                or HTML training materials) because, most likely, the learning content will not
                                be playable by learners using mobile devices and modern desktop browsers.</span></p>


                    </div>
                </v-col>
            </v-row>
        </section>
    </v-container>
</layout-basic></template>

<script>
import LayoutBasic from "@/layouts/Dashboard";
export default {
    name: "Eula",
    metaInfo() {
        return {
                title: "IMPROVE End User License Agreement (EULA) | Terms of Use",
                meta: [
                        { name: 'description', content: "Read the IMPROVE End User License Agreement (EULA). Understand the terms and conditions for using IMPROVE's online microlearning platform and services." },
                        { name: 'keywords', content: "IMPROVE EULA, End User License Agreement, terms of use, IMPROVE terms, software license, online learning agreement" },
                        { property: 'og:title', content: "IMPROVE End User License Agreement (EULA) | Terms of Use" },
                        { property: 'og:description', content: "Read the IMPROVE End User License Agreement (EULA). Understand the terms and conditions for using IMPROVE's online microlearning platform and services." },
                        { property: 'og:image', content: "https://www.improve.online/static/SEO.png" },
                        { property: 'og:type', content: 'website' },
                        { property: 'og:url', content: 'https://www.improve.online/eula' },
                        { name: 'twitter:card', content: 'summary_large_image' },
                        { name: 'twitter:title', content: "IMPROVE End User License Agreement (EULA) | Terms of Use"  },
                        { name: 'twitter:description', content: "Read the IMPROVE End User License Agreement (EULA). Understand the terms and conditions for using IMPROVE's online microlearning platform and services." },
                        { name: 'twitter:image', content: "https://www.improve.online/static/SEO.png" }
                ],
                link: [
                        { rel: 'canonical', href: 'https://www.improve.online/eula' }
                ]
        };
    },
    components: {
        LayoutBasic
    }
};
</script>
